import type { NarrativeValuation } from '../../hooks/useNarrativeById';

export const hasOnlyFairValue = (valuation: NarrativeValuation) => {
  return (
    !valuation.futurePePercentageChange &&
    !valuation.revenuePercentageChange &&
    !valuation.profitMarginPercentageChange &&
    !!valuation.fairValue
  );
};
